import { FC, useState, ChangeEvent, FormEvent } from "react";
import { Input } from "../../components/ui/Input";
import { Button } from "../../components/ui/Button";
import { validateEmail } from '../../utils';
import { forgotPassword } from "../../services/authService";
import { useAuth } from "../../contexts/AuthContext";

export const ForgotPassword: FC = () => {
    const [form, setForm] = useState<{ [key: string]: { value: string, error: string } }>({ email: { value: '', error: '' } });
    const { setIsAuthOpen } = useAuth();
    const { setCurrentScreen } = useAuth();

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setForm(prev => ({ ...prev, [e.target.name]: { ...prev[e.target.name], value: e.target.value, error: '' } }));
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (validateEmail(form.email.value)) {
            setForm(prev => ({ ...prev, email: { ...prev.email, error: validateEmail(form.email.value) } }));
        } else {
            forgotPassword({ email: form.email.value }).then(response => {
                setCurrentScreen("signIn");
            }).catch(error => {
                setForm(prev => ({ ...prev, email: { ...prev.email, error: error.response.data.message } }));
            });
        }
    };

    return (    
        <section className="flex flex-col gap-4 w-full">
            <h2 className="sm:text-2xl text-xl font-medium text-center text-white">Change Password</h2>
            <form className="flex flex-col gap-4" noValidate onSubmit={handleSubmit}>
                <Input
                    variant="secondary"
                    type="email"
                    name="email"
                    label="Email"
                    placeholder="Enter your email"
                    error={form.email.error}
                    value={form.email.value}
                    onChange={handleChange}
                    className={`w-full`}
                />
                <Button
                    type="submit"
                    variant="primary"
                    className="w-full mt-2"
                >
                    Reset Password
                </Button>
            </form>
        </section>
    );
};